module.exports = __webpack_public_path__ + "img/banner_left.d29d9a58.jpg";